import {createAsyncThunk} from '@reduxjs/toolkit';
import {itemsApi} from 'api';
import {toastNotificationManager} from 'toast-notifications';
import {itemsMessages} from '../../utils';
import {prefix} from './config';

export const unPublishItemAnswerStackThunk: any = createAsyncThunk<any, number>(
  `${prefix} unPublishItemAnswerStack`,
  async (answerStackId: number, {dispatch, rejectWithValue}) => {
    try {
      const {parsedBody} = await itemsApi.unPublishItemAnswerStack(answerStackId);
      dispatch(toastNotificationManager.createSuccessToastAction(itemsMessages.unPublishAnswerStackSuccess));
      return parsedBody;
    } catch (err) {
      dispatch(toastNotificationManager.createErrorToastAction(err.parsedBody));
      return rejectWithValue({error: err});
    }
  }
);
